export default "__VITE_ASSET__BAN7d7Zm__"